<footer class="footer">
  <div class="footer__inner">
    <div class="footer__grid">
      <div class="footer__brand">
        <a routerLink="/" class="footer__logo">
          <span>HNH</span>
          <small>Jewellery</small>
        </a>
        <p class="footer__tagline">
          Elegant, anti-tarnish jewellery designed for everyday luxury and lasting shine.
        </p>
        <div class="footer__socials">
          @if (settings()['instagram_url']) {
            <a [href]="settings()['instagram_url']" target="_blank" rel="noopener" aria-label="Instagram">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.2" cy="6.8" r="1" fill="currentColor" stroke="none"/></svg>
            </a>
          }
          @if (settings()['facebook_url']) {
            <a [href]="settings()['facebook_url']" target="_blank" rel="noopener" aria-label="Facebook">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M14 8h3V5h-3a4 4 0 00-4 4v2H7v3h3v6h3v-6h3l1-3h-4V9a1 1 0 011-1z"/></svg>
            </a>
          }
          <a [href]="whatsappLink" target="_blank" rel="noopener" aria-label="WhatsApp">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 3a9 9 0 00-7.8 13.5L3 21l4.7-1.2A9 9 0 1012 3z"/><path d="M9 9.5c.5 2.5 3 5 5.5 5.5l1.5-1.5-2-1.5-1 .7c-.8-.4-1.8-1.4-2.2-2.2l.7-1L10 7.5 9 9.5z"/></svg>
          </a>
        </div>
      </div>

      <nav class="footer__col" aria-label="Quick links">
        <h4>Quick Links</h4>
        <a routerLink="/shop">Shop All</a>
        <a routerLink="/shop" [queryParams]="{ filter: 'new' }">New Arrivals</a>
        <a routerLink="/shop" [queryParams]="{ filter: 'trending' }">Best Sellers</a>
        <a routerLink="/shop" [queryParams]="{ filter: 'sale' }">Sale</a>
        <a routerLink="/about">About Us</a>
        <a routerLink="/contact">Contact</a>
      </nav>

      <nav class="footer__col" aria-label="Collections">
        <h4>Collections</h4>
        @for (collection of collections(); track collection.id) {
          <a routerLink="/shop" [queryParams]="{ collection: collection.slug }">{{ collection.name }}</a>
        }
        <a routerLink="/collections">All Collections</a>
      </nav>

      <div class="footer__col">
        <h4>Get in Touch</h4>
        @if (settings()['support_email']) {
          <a [href]="'mailto:' + settings()['support_email']">{{ settings()['support_email'] }}</a>
        }
        <a [href]="whatsappLink" target="_blank" rel="noopener">WhatsApp Us</a>

        <h4 class="footer__pay-title">Payments</h4>
        <p class="footer__pay">
          {{ settings()['meezan_bank_name'] || 'Meezan Bank' }} ·
          {{ settings()['meezan_account_number'] || '01070109303886' }}
        </p>
        <p class="footer__pay">
          EasyPaisa · {{ settings()['easypaisa_account_number'] || '03463675594' }}
        </p>
      </div>

      <div class="footer__col footer__newsletter">
        <h4>Newsletter</h4>
        <p>Sign up for new drops, restocks and members-only offers.</p>
        <form (ngSubmit)="subscribe()">
          <input
            type="email"
            name="email"
            required
            placeholder="Your email address"
            [ngModel]="email()"
            (ngModelChange)="email.set($event)"
            aria-label="Email address"
          />
          <button type="submit" class="btn" [disabled]="newsletterState() === 'sending'">
            {{ newsletterState() === 'sending' ? 'Joining…' : 'Join' }}
          </button>
        </form>
        @if (newsletterState() === 'done') {
          <p class="footer__note footer__note--ok">You’re on the list. Welcome to HNH.</p>
        } @else if (newsletterState() === 'error') {
          <p class="footer__note footer__note--err">Something went wrong — please try again.</p>
        }
      </div>
    </div>

    <div class="footer__bottom">
      <p>© {{ year }} HNH Jewellery. All rights reserved.</p>
      <p>Trendy anti-tarnish jewellery, delivered across Pakistan.</p>
      <p>
        Site developed by:
        <a href="mailto:hr803349&#64;gmail.com">hr803349&#64;gmail.com</a>
      </p>
    </div>
  </div>
</footer>
